export enum VerificationCriteriaStatus {
  PENDING = 'pending',
  ACCEPTED = 'accepted',
  REJECTED = 'rejected',
  MISSING_EVIDENCE = 'missingEvidence',
}

export interface VerificationCriteriaParams {
  id: string;
  createdAt?: Date | string;
  updatedAt?: Date | string;
  title?: string;
  description?: string;
  requirementId: string;
  propelOrgId: string;
  status: VerificationCriteriaStatus;
}

export interface VerificationCriteriaData {
  id: string;
  createdAt?: string;
  updatedAt?: string;
  title: string;
  description: string;
  requirementId: string;
  propelOrgId: string;
  status: VerificationCriteriaStatus;
}

export type VerificationCriteriaCreateData = Omit<VerificationCriteriaParams, 'id' | 'createdAt' | 'updatedAt' | 'status'>;

/** Row payload for bulk insert; `propelOrgId` is supplied as a single argument to {@link VerificationCriteriaAccess.bulkCreate}. */
export type VerificationCriteriaBulkCreateData = Pick<
  VerificationCriteriaParams,
  'requirementId' | 'title' | 'description' | 'status'  | 'id'
>
